import { render, staticRenderFns } from "./SkeletonCompPeopleTourProgress.vue?vue&type=template&id=a8f4bf8e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports